import {
    CANCEL_NOTIFICATION_TASK_FAILURE,
    CANCEL_NOTIFICATION_TASK_REQUEST,
    CANCEL_NOTIFICATION_TASK_SUCCESS,
    GET_NOTIFICATION_TASK_FAILURE,
    GET_NOTIFICATION_TASK_REQUEST,
    GET_NOTIFICATION_TASK_SUCCESS,
    SEARCH_NOTIFICATION_FAILURE,
    SEARCH_NOTIFICATION_REQUEST,
    SEARCH_NOTIFICATION_SUCCESS,
    SEND_NOTIFICATION,
    SEND_NOTIFICATION_ERROR,
    SEND_NOTIFICATION_SUCCESS,
    CLEAR_LAST_NOTIFICATION_DETAILS,
    GET_NOTIFICATION_TEMPLATES_REQUEST,
    GET_NOTIFICATION_TEMPLATES_SUCCESS,
    GET_NOTIFICATION_TEMPLATES_FAILURE,
    GET_NOTIFICATION_TEMPLATE_SUCCESS,
    CREATE_NOTIFICATION_TEMPLATE_REQUEST,
    CREATE_NOTIFICATION_TEMPLATE_SUCCESS,
    CREATE_NOTIFICATION_TEMPLATE_FAILURE,
    UPDATE_NOTIFICATION_TEMPLATE_REQUEST,
    UPDATE_NOTIFICATION_TEMPLATE_SUCCESS,
    UPDATE_NOTIFICATION_TEMPLATE_FAILURE,
    DELETE_NOTIFICATION_TEMPLATE_REQUEST,
    DELETE_NOTIFICATION_TEMPLATE_SUCCESS,
    DELETE_NOTIFICATION_TEMPLATE_FAILURE,
    SET_NOTIFICATION_TEMPLATE_SEARCH,
    CLEAR_SELECTED_NOTIFICATION_TEMPLATE,
} from "../action/types";

const initialState = {
    sendNotificationInProgress: false,
    sendNotificationSuccess: false,
    sendNotificationFailure: false,
    notificationDetails: {},
    lastNotificationDetails: {},
    taskList: [],
    lastAction: "",
    templates: [],
    templatesLoading: false,
    templatesError: null,
    selectedTemplate: null,
    templateSearch: "",
    templateMutationInProgress: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SEND_NOTIFICATION:
            return {
                ...state,
                sendNotificationInProgress: true,
                sendNotificationSuccess: false,
                sendNotificationFailure: false,
            }
        case GET_NOTIFICATION_TASK_REQUEST:
        case CANCEL_NOTIFICATION_TASK_REQUEST:
        case SEARCH_NOTIFICATION_REQUEST:
            return {
                ...state,
            }
        case GET_NOTIFICATION_TASK_SUCCESS:
            return {
                ...state,
                ...(() => {
                    if (action?.payload?.action === "updateSentNotification") {
                        return { lastNotificationDetails: action?.payload?.data }
                    }
                    else {
                        return { notificationDetails: action?.payload?.data }
                    }
                })(),
                lastAction: "get_notification_task" + action?.payload?.taskId + Date?.now()
            }
        case SEARCH_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notificationDetails: action?.payload,
                lastAction: "search_notification_success" + Date?.now()
            }
        case SEND_NOTIFICATION_SUCCESS:
            return {
                ...state,
                sendNotificationInProgress: false,
                sendNotificationSuccess: true,
                sendNotificationFailure: false,
                lastNotificationDetails: payload,
                taskList: [...state?.taskList, payload?.taskId],
                lastAction: 'send_notification_success' + Date?.now()
            };
        case GET_NOTIFICATION_TASK_FAILURE:
            return {
                ...state,
                notificationDetails: {},
                lastAction: "get_notification_task_failure" + action?.payload?.taskId + Date?.now()
            }
        case SEARCH_NOTIFICATION_FAILURE:
            return {
                ...state,
                notificationDetails: [],
                lastAction: "search_notification_failure" + Date?.now()
            }
        case CANCEL_NOTIFICATION_TASK_SUCCESS:
            return {
                ...state
            }
        case CANCEL_NOTIFICATION_TASK_FAILURE:
            return {
                ...state
            }
        case SEND_NOTIFICATION_ERROR:
            return {
                ...state,
                sendNotificationInProgress: false,
                sendNotificationSuccess: false,
                sendNotificationFailure: true,
            };
        case CLEAR_LAST_NOTIFICATION_DETAILS:
            return {
                ...state,
                lastNotificationDetails: {},
                sendNotificationSuccess: false,
                sendNotificationFailure: false,
                sendNotificationInProgress: false,
            };
        case GET_NOTIFICATION_TEMPLATES_REQUEST:
            return {
                ...state,
                templatesLoading: true,
                templatesError: null,
            };
        case GET_NOTIFICATION_TEMPLATES_SUCCESS:
            return {
                ...state,
                templatesLoading: false,
                templates: payload || [],
                templatesError: null,
            };
        case GET_NOTIFICATION_TEMPLATES_FAILURE:
            return {
                ...state,
                templatesLoading: false,
                templatesError: payload || "Failed to fetch templates",
            };
        case GET_NOTIFICATION_TEMPLATE_SUCCESS:
            return {
                ...state,
                selectedTemplate: payload,
            };
        case CREATE_NOTIFICATION_TEMPLATE_REQUEST:
        case UPDATE_NOTIFICATION_TEMPLATE_REQUEST:
        case DELETE_NOTIFICATION_TEMPLATE_REQUEST:
            return {
                ...state,
                templateMutationInProgress: true,
            };
        case CREATE_NOTIFICATION_TEMPLATE_SUCCESS:
            return {
                ...state,
                templateMutationInProgress: false,
                selectedTemplate: payload,
                templates: [payload, ...(state.templates || []).filter((item) =>
                    (item.templateId || item.id) !== (payload?.templateId || payload?.id)
                )],
            };
        case UPDATE_NOTIFICATION_TEMPLATE_SUCCESS:
            return {
                ...state,
                templateMutationInProgress: false,
                selectedTemplate: payload,
                templates: (state.templates || []).map((item) =>
                    (item.templateId || item.id) === (payload?.templateId || payload?.id)
                        ? payload
                        : item
                ),
            };
        case DELETE_NOTIFICATION_TEMPLATE_SUCCESS:
            return {
                ...state,
                templateMutationInProgress: false,
                selectedTemplate:
                    (state.selectedTemplate?.templateId || state.selectedTemplate?.id) ===
                    (payload?.templateId || payload?.id)
                        ? null
                        : state.selectedTemplate,
                templates: (state.templates || []).filter((item) =>
                    (item.templateId || item.id) !== (payload?.templateId || payload?.id)
                ),
            };
        case CREATE_NOTIFICATION_TEMPLATE_FAILURE:
        case UPDATE_NOTIFICATION_TEMPLATE_FAILURE:
        case DELETE_NOTIFICATION_TEMPLATE_FAILURE:
            return {
                ...state,
                templateMutationInProgress: false,
            };
        case SET_NOTIFICATION_TEMPLATE_SEARCH:
            return {
                ...state,
                templateSearch: payload || "",
            };
        case CLEAR_SELECTED_NOTIFICATION_TEMPLATE:
            return {
                ...state,
                selectedTemplate: null,
            };
        default:
            return state;
    }
}
